'use strict';
var seatMapDescriptorCollection = Backbone.Collection.extend({
    model: require('../models/seatmap_descriptor.model'),

    fillData: function(descriptors, segment, section) {
        this.section = section;
        this.segment = segment;
        this.reset(descriptors);
    },
    refreshData: function() {
        this.isEmptyData = false;
        this.refresh();
    },
    getSeat: function(searchPattern) {
        return Odigeo._.extend(this.findWhere(searchPattern), {
            section: this.section,
            segment: this.segment,
        });
    },
});

module.exports = seatMapDescriptorCollection;
